/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsVehicleValidationTemplateData } from '../../models/mail-params-vehicle-validation-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendVehicleValidationMail$Params {
      body: MailParamsVehicleValidationTemplateData
}

export function sendVehicleValidationMail(http: HttpClient, rootUrl: string, params: SendVehicleValidationMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendVehicleValidationMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendVehicleValidationMail.PATH = '/sendMail/vehicle-validation';
